import { render } from "./CreateProductCard.vue?vue&type=template&id=60e112bc&scoped=true"
import script from "./CreateProductCard.vue?vue&type=script&lang=js"
export * from "./CreateProductCard.vue?vue&type=script&lang=js"

import "./CreateProductCard.vue?vue&type=style&index=0&id=60e112bc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e112bc"]])

export default __exports__